export default "__VITE_ASSET__DlCN$a8u__"